//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import roleload from './roleload'
import * as auth from "@/utils/auth";
import FfBreadcb from "@/pccomponents/FfBreadcb"
export default {
  name: 'role',
  components: {
    roleload,
    FfBreadcb
  },
  inject:['reload'],
  data() {
    return {
        tableData:[],//行项数据
        //分页数据
        pageinfo:{
          current: 1,// 当前页码
          length: 10,// 每页显示记录数
          count: 5,// 查询结果总记录数
        },

        activeName: 'first',

        queryinfo: {}, //查询条件

        editItemShow:true,//控制行项是否可新增删除
        ulstyle:2,//控制整体ul的列数

        delRowRoleIDs:'',//存储要批量删除的角色的roleid

        dialogVisible:false,
        roleid:'',
        flowsysid:'FLOW',
    }
  },
  created() {
    this.queryList();
  },
  mounted() {
  },
  methods: {
    /**
     * 初始化
     */
    queryList(){
      let url = "role/getlist";
      this.queryinfo.sysid=process.env.SYS_NAME;
      let params = {
        pageinfo:{
          currPage:this.pageinfo.current,
          rowsPerPage:this.pageinfo.length
        },
        queryinfo:this.queryinfo,
        flowsysid:this.flowsysid
      };
      this.axios.post(url, params).then(({ data }) => {
        this.tableData=data.data.record;
        this.pageinfo=data.data.pageinfo;
      }).catch(function(error){
        console.log(error)//错误处理 相当于error
      })
    },
    /**
     * 控制行项多选是否能编辑
     */
    checkboxT(){
      return true;
    },
    indexMethod(index) {
      //序号
      return index + 1;
    },
    /**
    * 分页记录
    */
    pageChange (item) {
      this.pageinfo.current = item.page_index;
      this.pageinfo.length = item.page_limit;
      this.queryList(); //改变页码，重新渲染页面
    },
    /**
     * 通过模态窗口新增
     */
    addAction(){
      this.roleid='';
      this.dialogVisible = true;
    },
    /**
     * 通过模态窗口查看和修改
     */
    modifityAction(row){
      this.roleid=row.roleid+'';
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 在模态框内点击确认
     */
    confirmAction(){
      // this.$refs.roleload.saveData().then((result)=>{
      //   if(result){
          this.dialogVisible = false;
        //   this.reload();
        // }
     // });
    },
    /**
     * 批量删除
     */
    delAction(){
      let url = "role/delete";
      let params = {
        billids:this.delRowRoleIDs,
        flowsysid:this.flowsysid,
      };
      this.axios.post(url, params).then(({ data }) => {
        if(data.code=='1'){
          this.reload();
        }else{
          console.log('2019年11月20日19:33:55 role.vue[删除失败]——[null] :',null);
        }
      }).catch(function(error){
        console.log(error)//错误处理 相当于error
      })
    },
    /**
     * 获取多选的值
     */
    handleSelectionChange(selections){
      this.delRowRoleIDs='';
      for(let selection of selections){
        if(this.delRowRoleIDs==''){
          this.delRowRoleIDs=selection.roleid;
        }else{
          this.delRowRoleIDs=this.delRowRoleIDs+';'+selection.roleid;
        }
      }
		},
		openModel() {
        this.setDialogPos();
    }
  },
}



// WEBPACK FOOTER //
// ./src/pcpage/ptooa/permission/role.vue